import React from 'react';
import PropTypes from 'prop-types';
// import Box from '@material-ui/core/Box';
import StyledRadioButton from 'components/pages/ResourceSetting/Widgets/StyledRadioButton';
import { Categories as PlatformCategories } from 'models/business/Platform';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import classNames from 'classnames';
// import WhiteTypography from '../../../../Common/WhiteTextTypography';
// import CarouselDoodle from './CarouselDoodle';
// import FeaturedDoodle from './FeaturedDoodle';
import Styles from './index.module.css';

const PresentationFormatTitles = {
  [PlatformCategories.FacebookCarousel]: '輪播',
  [PlatformCategories.FacebookFeatured]: '精選集',
  [PlatformCategories.FacebookReferral]: '導流',
  [PlatformCategories.FacebookImpression]: '曝光',
};

export default function PresentationFormatField({
  presentationFormat,
  onChangePresentationFormat,
}) {
  // const hasValidSelectedFormat = !!PresentationFormatTitles[presentationFormat];

  return (
    <div className={Styles.mainContainer}>
      <FormLabel title="廣告投放格式" />
      <div className={Styles.buttonPanel}>
        {Object.keys(PresentationFormatTitles).map((format) => (
          <StyledRadioButton
            key={format}
            className={classNames(
              Styles.formatButton,
              {
                // [Styles.formatButtonCollapsed]: hasValidSelectedFormat,
                [Styles.formatButtonCollapsed]: true,
                [Styles.formatButtonSelected]: presentationFormat === format,
              },
            )}
            onClick={() => onChangePresentationFormat(format)}
            selected={presentationFormat === format}
          >
            <div>{PresentationFormatTitles[format]}</div>
            {[PlatformCategories.FacebookCarousel, PlatformCategories.FacebookFeatured]
              .includes(format) && (
              <div>(CPAS)</div>
            )}
            {[PlatformCategories.FacebookReferral, PlatformCategories.FacebookImpression]
              .includes(format) && (
              <div>(非CPAS)</div>
            )}
            {/* {!hasValidSelectedFormat && (
              <>
                {format === PlatformCategories.FacebookCarousel && <CarouselDoodle />}
                {(
                  format === PlatformCategories.FacebookFeatured
                  || format === PlatformCategories.FacebookReferral
                  || format === PlatformCategories.FacebookImpression
                ) && <FeaturedDoodle />}
              </>
            )} */}
          </StyledRadioButton>
        ))}
      </div>
    </div>
  );
}

PresentationFormatField.propTypes = {
  presentationFormat: PropTypes.string,
  onChangePresentationFormat: PropTypes.func,
};

PresentationFormatField.defaultProps = {
  presentationFormat: '',
  onChangePresentationFormat: () => {},
};
